import React from 'react';
import PropTypes from 'prop-types';
import { AccountIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';
import MultiAccountContainerStyled from './styles/MultiAccountStyled';

const MultiAccountContainer = ({ selector, isMultiAccount, status }) => {
  return (
    <MultiAccountContainerStyled
      isMultiAccount={isMultiAccount}
      status={status}
    >
      <header>
        <AccountIcon />
        <span>Cuenta</span>
      </header>
      {selector}
    </MultiAccountContainerStyled>
  );
};

MultiAccountContainer.propTypes = {
  selector: PropTypes.node.isRequired,
  isMultiAccount: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
};

export default MultiAccountContainer;
